<div class="buttons">
	<button nz-button nzType="default" (click)="clear()">Clear</button>
</div>
@if (activity()) {
	<app-header
		[journeyStep]="JourneyStep.PLAY_ACTIVITY"
		[activity]="activity()"
		(info)="header.showInstructions()"
		#header
	></app-header>

	<app-player [activity]="activity()" [dontTrackTake]="true"></app-player>
}
